import React, { Component } from 'react';
import actions from '../actions';
import entityActions from '../../../baseApp/entities/actions';
import { connect } from 'react-redux';
import ConsoleUsersForm from './../components/ConsoleUsersForm';
import Validators from '../../../baseApp/shared/utils/Validators';
import { I18n } from 'react-redux-i18n';
import _ from '../../../baseApp/shared/utils/ObjectUtils';

class ConsoleUsersFormContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            viewMode: !_.isNilOrEmpty(props.consoleUserId),
            editMode: false,
            createMode: _.isNilOrEmpty(props.consoleUserId),
            alert: {
                show: false
            },
            consoleUserFormData: {
                username: {
                    value: undefined,
                    error: undefined,
                    required: true
                },
                password: {
                    value: undefined,
                    error: undefined,
                    required: true
                },
                confirmPassword: {
                    value: undefined,
                    error: undefined,
                    required: true
                },
                entity: {
                    value: undefined,
                    error: undefined,
                    data: [],
                    required: true
                },
                numberOfConnections: {
                    value: undefined,
                    error: undefined,
                    required: false
                },
                active: {
                    value: undefined,
                    error: undefined,
                    required: false
                },
                properties: {
                    consoleSettingsPIN: {
                        value: undefined,
                        error: undefined,
                        required: true
                    },
                    maxNumberOfConnections: {
                        value: undefined,
                        error: undefined,
                        required: true
                    }
                }
            }
        }
    }

    componentDidMount() {
        const { consoleUserId, getConsoleUserData, getEntityList } = this.props;

        if (!_.isUndefined(consoleUserId)) {
            getConsoleUserData(consoleUserId);
        }
        getEntityList();
    };

    componentWillReceiveProps(nextProps) {
        //Handle Error, Edit and Create
        if (this.props.loadingCreateRequest && !nextProps.loadingCreateRequest) {
            if (nextProps.consoleUserWasCreated) {
                this.handleConsoleUserCreateSuccess();
            } else {
                this.handleConsoleUserCreateError(nextProps.error)
            }
        } else if (this.props.loadingDeleteRequest && !nextProps.loadingDeleteRequest) {
            if (nextProps.consoleUserWasDeleted) {
                this.handleConsoleUserDeleteSuccess();
            } else {
                this.handleConsoleUserDeleteError(nextProps.error)
            }
        } else if (this.props.loadingEditRequest && !nextProps.loadingEditRequest) {
            if (nextProps.consoleUserWasEdited) {
                this.handleConsoleUserEditSuccess();
            } else {
                this.handleConsoleUserEditError(nextProps.error);
            }
        } else if (this.props.loadingConsoleUser && !nextProps.loadingConsoleUser) {
            this.handleConsoleUserLoadingCompleted(nextProps.consoleUserData)
        }
    };

    handlePropertyFieldChange = (id, value) => {
        this.setState({
            consoleUserFormData: {
                ...this.state.consoleUserFormData,
                properties: {
                    ...this.state.consoleUserFormData.properties,
                    [id]: {
                        ...this.state.consoleUserFormData.properties[id],
                        value: value
                    }
                }
            }
        }, () => {
            if (_.has(this.state.consoleUserFormData.properties[id], 'required')) {
                this.validateField(id, true);
            }
        })
    };

    handleFieldChange = (id, value) => {
        this.setState({
            consoleUserFormData: {
                ...this.state.consoleUserFormData,
                [id]: {
                    ...this.state.consoleUserFormData[id],
                    value: value
                }
            }
        }, () => {
            if (_.has(this.state.consoleUserFormData[id], 'required')) {
                this.validateField(id, false);
            }
        })
    };

    validateField = (key, propertyForm) => {
        let consoleUserFormData;
        if (propertyForm) {
            consoleUserFormData = { ...this.state.consoleUserFormData.properties };
        } else {
            consoleUserFormData = { ...this.state.consoleUserFormData };
        }
        let error = null;
        switch (key) {
            case 'username':
                error = !_.isNilOrEmpty(consoleUserFormData[key].value) ? (!Validators.hasSpecialCharacters(consoleUserFormData[key].value) ? I18n.t('consoleUser.form.userName.error') : undefined) : I18n.t('forms.errors.emptyRequiredField');
                break;
            case "email":
                error = !Validators.email(consoleUserFormData[key].value) ? I18n.t('consoleUser.errors.invalidEmail') : undefined;
                break;
            case "confirmPassword":
                error = consoleUserFormData[key].value === consoleUserFormData.password.value ? undefined : I18n.t('consoleUser.form.password.error');
                break;
            case "consoleSettingsPIN":
                error = !Validators.isConsolePin(consoleUserFormData[key].value) ? I18n.t('consoleUser.form.consoleSettingsPIN.error') : undefined;
                break;
            case "maxNumberOfConnections":
                error = !Validators.isInteger(consoleUserFormData[key].value) ? I18n.t('consoleUser.form.maxNumberOfConnections.error') : undefined;
                break;
            case "password":
                error = Validators.passwordLength(consoleUserFormData[key].value) ?
                    I18n.t('auth.errors.invalidPasswordLength', { charCount: "6" }) :
                    !Validators.password(consoleUserFormData[key].value) ?
                        I18n.t('auth.errors.invalidPassword') :
                        null;
                break;
            default:
                if (!_.isNilOrEmpty(consoleUserFormData[key].error) &&
                    consoleUserFormData[key].required &&
                    !_.isNilOrEmpty(consoleUserFormData[key].value)) {
                    error = undefined;
                } else if (consoleUserFormData[key].required &&
                    _.isNilOrEmpty(consoleUserFormData[key].value)) {
                    error = I18n.t('forms.errors.emptyRequiredField')
                }
                break;
        }
        if (error !== consoleUserFormData[key].error) {
            consoleUserFormData[key].error = error;
            if (!propertyForm) {
                this.setState({
                    consoleUserFormData,
                });
            } else {
                this.setState({
                    ...this.state.consoleUserFormData,
                    properties: {
                        ...consoleUserFormData,
                    },
                });
            }
        }
    };

    handleOnFieldBlur = (key, propertyForm) => {
        this.validateField(key, propertyForm)
    };

    handleSubmitClick = () => {
        const { editMode, consoleUserFormData } = this.state;
        const { consoleUserId, editConsoleUser, createConsoleUser } = this.props;
        let formHasErrors = false;

        _.forOwn(consoleUserFormData, (field, key) => {
            if(key === 'properties') {
                _.forOwn(field, subFormField => {
                    if (subFormField.required && _.isNilOrEmpty(subFormField.value)) {
                        subFormField.error = I18n.t('forms.errors.emptyRequiredField');
                        formHasErrors = true;
                    } else if(!_.isNilOrEmpty(subFormField.error)) {
                        formHasErrors = true;
                    } else {
                        subFormField.error = undefined;
                    }
                });
            } else {
                if((field.required && _.isNilOrEmpty(field.value))) {
                    field.error = I18n.t('forms.errors.emptyRequiredField');
                    formHasErrors = true;
                } else if(!_.isNilOrEmpty(field.error)) {
                    formHasErrors = true;
                } else {
                    field.error = undefined;
                }
            }
        });

        if (!formHasErrors) {
            const formDataToBeSubmitted = Object.entries(consoleUserFormData).reduce((acc, [key, formField]) => {
                if(key === 'properties') {
                    const subFormData = Object.entries(formField).reduce((subFormAcc, [subFormKey, subFormField]) => {
                        return {
                            ...subFormAcc,
                            [subFormKey]: subFormField.value
                        }
                    }, {});
                    return {
                        ...acc,
                        [key]: {
                            ...subFormData
                        }
                    }
                }
                return {
                    ...acc,
                    [key]: formField.value
                }
            }, {});

            const consoleUserName = formDataToBeSubmitted.username;
            if (editMode) {
                this.setState({
                    alert: {
                        show: true,
                        type: "warning",
                        title: I18n.t('consoleUser.alerts.edit.title'),
                        html: I18n.t('consoleUser.alerts.edit.text', { consoleUser: consoleUserName }),
                        confirmButtonText: I18n.t('forms.submit'),
                        cancelButtonText: I18n.t('forms.cancel'),
                        onCancel: this.hideAlert,
                        onConfirm: () => {
                            editConsoleUser(consoleUserId, formDataToBeSubmitted)
                        }
                    }
                })
            } else {
                this.setState({
                    alert: {
                        show: true,
                        type: "warning",
                        title: I18n.t('consoleUser.alerts.create.title'),
                        html: I18n.t('consoleUser.alerts.create.text', { consoleUser: consoleUserName }),
                        confirmButtonText: I18n.t('forms.submit'),
                        cancelButtonText: I18n.t('forms.cancel'),
                        onCancel: this.hideAlert,
                        onConfirm: () => {
                            createConsoleUser(formDataToBeSubmitted)
                        }
                    }
                })
            }
        } else {
            this.setState({
                consoleUserFormData,
            });
        }
    };

    handleEditClick = () => {
        const { editMode } = this.state;
        const { consoleUserData } = this.props;

        const formattedData = Object.entries(consoleUserData).reduce((acc, [key, formField]) => {
            if (consoleUserData[key]) {
                if (key === "properties") {
                    return {
                        ...acc,
                        [key]: {
                            ...Object.entries(formField).reduce((propertyAcc, [propertyKey, propertyValue]) => {
                                return {
                                    ...propertyAcc,
                                    [propertyKey]: {
                                        ...this.state.consoleUserFormData[key][propertyKey],
                                        value: propertyValue,
                                        error: undefined
                                    }
                                }
                            }, {})
                        }
                    }
                } else {
                    return {
                        ...acc,
                        [key]: {
                            ...acc[key],
                            ...this.state.consoleUserFormData[key],
                            value: consoleUserData[key],
                            error: undefined
                        }
                    }
                }
            } else {
                return acc;
            }
        }, {});

        if (editMode) {
            this.setState({
                editMode: false,
                viewMode: true,
                consoleUserFormData: {
                    ...this.state.consoleUserFormData,
                    ...formattedData
                }
            })
        } else {
            this.setState({
                viewMode: false,
                editMode: true
            })
        }
    };

    hideAlert = () => {
        this.setState({
            alert: {
                show: false
            }
        })
    };

    handleBackClick = () => {
        this.props.resetConsoleUserForm();
        this.hideAlert();
        this.props.history.push({
            pathname: '/consoleUsers',
            state: { 
                searchFieldsData : this.props.location.state?.searchFieldsData, 
                universalSearchField :  this.props.location.state?.universalSearchField
            }
        });
    };

    handleDeleteClick = () => {
        const { consoleUserId, deleteConsoleUser } = this.props;
        const {
            consoleUserFormData: {
                username: {
                    value: username
                }
            }
        } = this.state;

        this.setState({
            alert: {
                show: true,
                type: "warning",
                title: I18n.t('consoleUser.alerts.delete.title'),
                html: I18n.t('consoleUser.alerts.delete.text', { consoleUser: username }),
                confirmButtonText: I18n.t('forms.delete'),
                cancelButtonText: I18n.t('forms.cancel'),
                onCancel: this.hideAlert,
                onConfirm: () => {
                    deleteConsoleUser(consoleUserId)
                }
            }
        })
    };

    handleConsoleUserDeleteSuccess = () => {
        const {
            consoleUserFormData: {
                username: {
                    value: username
                }
            }
        } = this.state;

        this.setState({
            alert: {
                show: true,
                type: 'success',
                title: I18n.t('consoleUser.alerts.delete.success.title'),
                html: I18n.t('consoleUser.alerts.delete.success.text', { consoleUser: username }),
                confirmButtonText: I18n.t('forms.ok'),
                onCancel: this.handleBackClick,
                onConfirm: this.handleBackClick
            }
        })
    };

    handleConsoleUserDeleteError = error => {
        this.setState({
            alert: {
                show: true,
                type: 'error',
                title: I18n.t('consoleUser.alerts.delete.error.title'),
                html: I18n.t('consoleUser.alerts.delete.error.text'),
                confirmButtonText: I18n.t('forms.ok'),
                onConfirm: this.hideAlert
            }
        })
    };

    handleConsoleUserCreateSuccess = () => {
        const {
            consoleUserFormData: {
                username: {
                    value: username
                }
            }
        } = this.state;

        this.setState({
            alert: {
                show: true,
                type: 'success',
                title: I18n.t('consoleUser.alerts.create.success.title'),
                html: I18n.t('consoleUser.alerts.create.success.text', { consoleUser: username }),
                confirmButtonText: I18n.t('forms.ok'),
                onCancel: this.handleBackClick,
                onConfirm: this.handleBackClick
            }
        })
    };

    handleConsoleUserCreateError = error => {
        this.setState({
            alert: {
                show: true,
                type: 'error',
                title: I18n.t('consoleUser.alerts.create.error.title'),
                html: I18n.t('consoleUser.alerts.create.error.text'),
                confirmButtonText: I18n.t('forms.ok'),
                onConfirm: this.hideAlert
            }
        })
    };

    handleConsoleUserEditSuccess = () => {
        const {
            consoleUserFormData: {
                username: {
                    value: username
                }
            }
        } = this.state;

        this.setState({
            alert: {
                show: true,
                type: 'success',
                title: I18n.t('consoleUser.alerts.edit.success.title'),
                html: I18n.t('consoleUser.alerts.edit.success.text', { consoleUser: username }),
                confirmButtonText: I18n.t('forms.ok'),
                onCancel: this.handleBackClick,
                onConfirm: this.handleBackClick
            }
        })
    };

    handleConsoleUserEditError = error => {
        this.setState({
            alert: {
                show: true,
                type: 'error',
                title: I18n.t('consoleUser.alerts.edit.error.title'),
                html: I18n.t('consoleUser.alerts.edit.error.text'),
                confirmButtonText: I18n.t('forms.ok'),
                onConfirm: this.hideAlert
            }
        })
    };

    handleConsoleUserLoadingCompleted = consoleUserData => {
        const formattedData = Object.entries(consoleUserData).reduce((acc, [key, value]) => {
            if (key === "properties") {
                return {
                    ...acc,
                    [key]: {
                        ...Object.entries(value).reduce((propertyAcc, [propertyKey, propertyValue]) => {
                                return {
                                    ...propertyAcc,
                                    [propertyKey]: {
                                        ...this.state.consoleUserFormData[key][propertyKey],
                                        value: propertyValue
                                    }
                                }
                        }, { })
                    }
                }
            } else {
                return {
                    ...acc,
                    [key]: {
                        ...acc[key],
                        ...this.state.consoleUserFormData[key],
                        value: value
                    }
                }
            }
        }, {});
        this.setState({
            consoleUserFormData: {
                ...this.state.consoleUserFormData,
                ...formattedData,
            }
        });
    };

    render() {
        const {
            createMode,
            editMode,
            viewMode,
            consoleUserFormData,
            alert
        } = this.state;

        const {
            entityList,
            loadingDeleteRequest,
            loadingCreateRequest,
            loadingEditRequest,
            consoleUserData: {
                lastCommunication
            }
        } = this.props;

        return <ConsoleUsersForm
            editMode={editMode}
            createMode={createMode}
            viewMode={viewMode}
            alert={{
                ...alert,
                loading: loadingDeleteRequest || loadingCreateRequest || loadingEditRequest
            }}

            consoleUserFormData={consoleUserFormData}
            entityList={entityList}
            lastCommunication={lastCommunication}

            handleFieldChange={this.handleFieldChange}
            handleOnFieldBlur={this.handleOnFieldBlur}
            handleSubmitClick={this.handleSubmitClick}
            handlePropertyFieldChange={this.handlePropertyFieldChange}

            handleEditClick={this.handleEditClick}
            handleDeleteClick={this.handleDeleteClick}
            handleBackClick={this.handleBackClick}
        />
    }
}

const mapStateToProps = ({ consoleUsersReducer, entitiesReducer }) => {
    return {
        entityList: entitiesReducer.entityList,

        consoleUserData: consoleUsersReducer.consoleUserData,
        loadingConsoleUser: consoleUsersReducer.loading,
        error: consoleUsersReducer.error,

        loadingDeleteRequest: consoleUsersReducer.loadingDeleteRequest,
        consoleUserWasDeleted: consoleUsersReducer.consoleUserWasDeleted,

        loadingCreateRequest: consoleUsersReducer.loadingCreateRequest,
        consoleUserWasCreated: consoleUsersReducer.consoleUserWasCreated,

        loadingEditRequest: consoleUsersReducer.loadingEditRequest,
        consoleUserWasEdited: consoleUsersReducer.consoleUserWasEdited
    };
};

const mapDispatchToProps = {
    getConsoleUserData: actions.getConsoleUserData,
    createConsoleUser: actions.createConsoleUser,
    editConsoleUser: actions.editConsoleUser,
    deleteConsoleUser: actions.deleteConsoleUser,
    resetConsoleUserForm: actions.resetConsoleUserForm,
    getEntityList: entityActions.getEntityList,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ConsoleUsersFormContainer);
